import PropTypes from 'prop-types';

/**
 * AutosuggesOptionComponent: default uses the AutosuggestOption component in this directory but you can supply another
 * inputValue: controlled component
 * keepDataOnBlur: when falsy, input clears on blur/escape. Pass `true` to retain input
 *   on blur/escape, or an options object (e.g. `{ resetHighlightOnClear: true }`) to also
 *   reset the highlighted index when the input is cleared
 *   when using controlled highlightedIndex, parent must mirror
 *   onHighlightedIndexChange updates for this to take effect
 * clearButtonLabel: optional accessible name for the clear ("X") button; defaults to 'Clear input'
 * downshiftInputProps: props to pass to the input from downshift's getInputProps
 * inputError: optional element to render an error message
 * inputId: defaults to 'typeahead-input'
 * inputRef: not required, use only if you programmatically need to focus the input or get something from it
 * isLoading: data is loading - to be shown in place of no results if no results is to be shown
 * labelSibling: optional element to render next to the label
 * showDownCaret: optional flag to show the down caret/arrow
 * showError: optional flag to show the error state
 * stateReducer: optional function to modify the state of Downshift - e.g. handle escape to not clear
 */
export const AutosuggestProps = {
  AutosuggestOptionComponent: PropTypes.elementType,
  clearButtonLabel: PropTypes.string,
  clearOnEscape: PropTypes.bool,
  downshiftInputProps: PropTypes.object,
  handleOnSelect: PropTypes.func.isRequired,
  highlightedIndex: PropTypes.number,
  inputContainerClassName: PropTypes.string,
  inputError: PropTypes.element,
  inputId: PropTypes.string,
  inputRef: PropTypes.object,
  isItemDisabled: PropTypes.func,
  isLoading: PropTypes.bool,
  inputValue: PropTypes.string.isRequired,
  itemToString: PropTypes.func,
  keepDataOnBlur: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  label: PropTypes.element.isRequired,
  labelSibling: PropTypes.element,
  loadingMessage: PropTypes.string,
  onClearClick: PropTypes.func.isRequired,
  onHighlightedIndexChange: PropTypes.func,
  onInputValueChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedItem: PropTypes.object,
  showDownCaret: PropTypes.bool,
  showOptionsRestriction: PropTypes.bool,
  showError: PropTypes.bool,
  stateReducer: PropTypes.func,
};
